/*
 * Reaktivt tillstånd för importfliken. Delas av GymImportTab och panelerna
 * (i stället för att skicka och mutera props). Ett bundle åt gången.
 */
import { reactive, computed } from 'vue';
import {
  DATASET_DEFS, applyDedup, datasetCounts, bundlePlannedTotal,
  sessionsBlockingReason, activitiesBlockingReason,
} from './importModel.js';

export const importState = reactive({
  phase: 'idle',          // idle | parsing | review | running | done
  rev: 0,                 // bumpas av touch() när (icke-reaktiva) poster ändras
  parseProgress: '',      // text under inläsning ("Läser 3/12 filer …")
  cancelRequested: false, // sätts av Avbryt-knappen under körning
  bundle: null,
  existing: null,
  error: '',
  panel: null,            // dataset-nyckel för öppen panel
  plan: [],               // datatyper som körs (sätts när importen startar)
  progress: {},           // datasetKey → { done, total, label }
  result: null,
  activityTypes: [],
  mode: 'mock',           // mock | live
});

// Anropas efter varje ändring av poster (selected/status) så computeds räknar om.
export function touch() { importState.rev++; }

export function setBundle(bundle, existing) {
  importState.bundle = applyDedup(bundle, existing);
  importState.rev++;
  importState.existing = existing;
  importState.mode = bundle.mock ? 'mock' : 'live';
  importState.phase = 'review';
  importState.error = '';
  importState.panel = null;
  importState.result = null;
  importState.progress = {};
}

// Kör om dedup (t.ex. efter att användaren ändrat val som påverkar överlapp).
export function refreshDedup() {
  if (importState.bundle) { applyDedup(importState.bundle, importState.existing || {}); touch(); }
}

export function resetImport() {
  importState.phase = 'idle';
  importState.bundle = null;
  importState.existing = null;
  importState.error = '';
  importState.panel = null;
  importState.progress = {};
  importState.result = null;
  importState.parseProgress = '';
  importState.cancelRequested = false;
}

export function openPanel(key) { importState.panel = key; }
export function closePanel() { importState.panel = null; }

export function dataset(key) { return importState.bundle?.datasets[key] ?? null; }

export const cards = computed(() => {
  const b = importState.bundle;
  void importState.rev;
  if (!b) return [];
  return DATASET_DEFS.map(def => {
    const ds = b.datasets[def.key];
    return { def, ds, counts: datasetCounts(ds), blocking: blockingFor(def.key) };
  }).filter(c => c.ds.items.length > 0 || c.ds.skippedCount > 0);
});

export function blockingFor(key) {
  const b = importState.bundle;
  if (!b) return null;
  if (key === 'sessions') return sessionsBlockingReason(b);
  if (key === 'activities') return activitiesBlockingReason(b);
  return null;
}

export const plannedTotal = computed(() => { void importState.rev; return importState.bundle ? bundlePlannedTotal(importState.bundle) : 0; });
export const blockingReasons = computed(() => {
  void importState.rev;
  return importState.bundle ? DATASET_DEFS.map(d => blockingFor(d.key)).filter(Boolean) : [];
});
export const canRun = computed(() => plannedTotal.value > 0 && blockingReasons.value.length === 0);
